var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowInvitations)?_c('div',{staticClass:"col-md-6"},[_c('InvitationCard',{attrs:{"person":_vm.person}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }